/*eslint react-hooks/exhaustive-deps: "off"*/
import React, {useCallback, useContext, useEffect, useState} from "react";
import {Checkbox, Form, message} from "antd";
import {Title} from "./Common";
import MapPropsContext from "../MapPropsContext";
import Radio from "antd/es/radio";

const OPTIONS_CUSTOMER = [
  {value: '', label: '전체'},
  {value: 1, label: '3.5G'},
  {value: 2, label: '28G'},
];



/*

 */

function WidgetImpCheckFilter({disabled, currentPark}) {
  const {
    widgetState,
    onChangeWidgetState,
    isHideFilteredPointsLayer,
    setIsHideFilteredPointsLayer,
  } = useContext(MapPropsContext);


  const {agency_name, service_code, extra_search} = widgetState;
//  const [activeExtraInfo , setActiveExtraInfo] = useState(extra_search);




  useEffect(() => {
//    setActiveExtraInfo(false);
  }, [currentPark]);

  return (
    <Form.Item>
      {/*<Switch defaultChecked={true}*/}
      {/*          onChange={checked => {*/}
      {/*            onChangeWidgetState({target: {name: 'isRangeByYear', value: checked}});*/}
      {/*          }}*/}
      {/*          unCheckedChildren={"선택 활성화"}*/}
      {/*          checkedChildren={"선택 해제"}*/}
      {/*        style={{marginLeft: '220px'}}*/}
      {/*/>*/}
      <Radio.Group name="agency_name"
                   value={agency_name}
                   buttonStyle={"solid"}
                   size={"small"}
                   onChange={onChangeWidgetState}
                   style={{width: '100%'}}>
        <Title >
          사업자
        </Title>
        <div style={{display: 'flex', marginBottom: '1em', width: '100%'}}>
          {OPTIONS_CUSTOMER.map(({value, label}) =>
            <Radio.Button value={value} key={value} style={BUTTON_STYLE}
                          disabled={disabled || isHideFilteredPointsLayer}>
              {label}
            </Radio.Button>
          )}
        </div>

      </Radio.Group>

    </Form.Item>
  );
}


const BUTTON_STYLE = {
  flex: 1,
  textAlign: 'center',
};


export default WidgetImpCheckFilter;